import { render } from "./AddCmsPage.vue?vue&type=template&id=42a61552&lang=html"
import script from "./AddCmsPage.vue?vue&type=script&lang=js"
export * from "./AddCmsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__